const vistasConfig = {
  "cuentas-paquetes": {
    label: "Cuentas y Paquetes",
    segment: "CuentaPaquete",
    items: {
      "comisiones-intereses": {
        label: "Comisiones / Intereses",
        subSegment: "FormularioContacto"
      },
      "adquisicion-producto": {
        label: "Adquisición de un nuevo producto",
        subSegment: "FormularioContacto"
      },
      "desconoce-producto": {
        label: "Desconoce producto",
        subSegment: "FormularioContacto"
      },
      anses: {
        label: "Anses",
        subSegment: "FormularioContacto"
      },
      "cierre-baja": {
        label: "Cierre / Baja / No renovación de productos",
        help: "consulta/BajaProductos"
      },
      "cbu-alias": {
        label: "CBU/Alias",
        help: "consulta/CbuAlias"
      },
      "desconocimiento-compra": {
        label: "Desconocimiento de compra/consumo",
        subSegment: "FormularioContacto"
      },
      "estado-tramite": {
        label: "Estado de trámite efectuado",
        subSegment: "FormularioContacto"
      },
      "formas-pago": {
        label: "Formas de pago de tarjetas de crédito",
        help: "consulta/FormasPago"
      },
      "pago-servicios": {
        label: "Pago de servicios",
        subSegment: "FormularioContacto"
      },
      promociones: {
        label: "Promociones",
        subSegment: "FormularioContacto"
      },
      resumenes: {
        label: "Resúmenes",
        subSegment: "FormularioContacto"
      },
      "estafa-fraude": {
        label: "Estafas y Fraudes",
        subSegment: "FormularioContacto"
      },
      "robo-perdida": {
        label: "Robo o pérdida de tarjetas",
        help: "consulta/RoboPerdida"
      },
      "saldos-movimientos": {
        label: "Saldos y movimientos",
        subSegment: "FormularioContacto"
      },
      otros: {
        label: "Otros",
        subSegment: "FormularioContacto"
      }
    }
  },
  "tarjetas-credito": {
    label: "Tarjetas de Crédito",
    segment: "TarjetaCredito",
    items: {
      "formas-pago": {
        label: "Formas de pago de tarjetas de crédito",
        help: "consulta/FormasPago"
      },
      "desconoce-producto": {
        label: "Desconoce producto",
        subSegment: "FormularioContacto"
      },
      "adquisicion-producto": {
        label: "Adquisición de un nuevo producto",
        subSegment: "FormularioContacto"
      },
      "comisiones-intereses": {
        label: "Comisiones / Intereses",
        subSegment: "FormularioContacto"
      },
      "estado-tramite": {
        label: "Estado de trámite efectuado",
        subSegment: "FormularioContacto"
      },
      "desconocimiento-compra": {
        label: "Desconocimiento de compra/consumo",
        help: "consulta/DesconocimientoConsumo"
      },
      limites: {
        label: "Límites",
        subSegment: "FormularioContacto"
      },
      "autorizacion-compra": {
        label: "Autorización de compras",
        help: "consulta/AutorizacionCompra"
      },
      promociones: {
        label: "Promociones",
        subSegment: "FormularioContacto"
      },
      "reponer-inhabilitar": {
        label: "Reponer / Inhabilitar tarjeta",
        help: "consulta/ReponerReimpresion"
      },
      "asistencia-viajero": {
        label: "Asistencia al viajero",
        help: "consulta/AsistenciaViajero"
      },
      "acceso-vip": {
        label: "Acceso a salones VIP",
        subSegment: "FormularioContacto"
      },
      "reintegro-impuestos": {
        label: "Reintegro / Consulta impuestos",
        subSegment: "FormularioContacto"
      },
      "devolucion-pago": {
        label: "Reintegro / Devolución de pago",
        subSegment: "FormularioContacto"
      },
      resumenes: {
        label: "Resúmenes",
        subSegment: "FormularioContacto"
      },
      "seguimiento-tarjeta": {
        label: "Seguimiento de tarjeta",
        subSegment: "FormularioContacto"
      },
      "solicitud-baja": {
        label: "Solicitud de baja",
        subSegment: "FormularioContacto"
      },
      "estafa-fraude": {
        label: "Estafas y Fraudes",
        subSegment: "FormularioContacto"
      },
      otros: {
        label: "Otros",
        subSegment: "FormularioContacto"
      }
    }
  },
  inversiones: {
    label: "Inversiones",
    segment: "Inversiones",
    items: {
      "comisiones-intereses": {
        label: "Comisiones / Intereses",
        subSegment: "FormularioContacto"
      },
      "adquisicion-producto": {
        label: "Adquisición de un nuevo producto",
        subSegment: "FormularioContacto"
      },
      acciones: {
        label: "Acciones",
        subSegment: "FormularioContacto"
      },
      cedears: {
        label: "Cedears",
        subSegment: "FormularioContacto"
      },
      bonos: {
        label: "Bonos",
        subSegment: "FormularioContacto"
      },
      dolares: {
        label: "Compra y venta de dólares",
        subSegment: "FormularioContacto"
      },
      "cuenta-custodia": {
        label: "Cuenta Custodia",
        subSegment: "FormularioContacto"
      },
      "estado-tramite": {
        label: "Estado de trámite efectuado",
        subSegment: "FormularioContacto"
      },
      fci: {
        label: "FCI",
        subSegment: "FormularioContacto"
      },
      "licitaciones-primaria": {
        label: "Licitaciones Primarias",
        subSegment: "FormularioContacto"
      },
      "plazo-fijo": {
        label: "Plazo Fijo",
        subSegment: "FormularioContacto"
      },
      "estafa-fraude": {
        label: "Estafas y Fraudes",
        subSegment: "FormularioContacto"
      },
      otros: {
        label: "Otros",
        subSegment: "FormularioContacto"
      }
    }
  },
  "caja-seguridad": {
    label: "Caja de Seguridad",
    segment: "CajaSeguridad",
    items: {
      "adquisicion-producto": {
        label: "Adquisición de un nuevo producto",
        help: "consulta/AdquisicionProducto"
      },
      otros: {
        label: "Otros",
        subSegment: "FormularioContacto"
      }
    }
  },
  prestamos: {
    label: "Préstamos",
    segment: "Prestamos",
    items: {
      "prestamo-hipotecario": {
        label: "Quiero contratar un préstamo hipotecario",
        subSegment: "FormularioContacto"
      },
      "prestamo-personal": {
        label: "Quiero contratar un préstamo personal",
        subSegment: "FormularioContacto"
      },
      "prestamo-prendario": {
        label: "Quiero contratar un préstamo prendario",
        help: "adquisicion/PrestamosPrendarios"
      },
      "desconoce-producto": {
        label: "Desconoce producto",
        subSegment: "FormularioContacto"
      },
      "adelanto-sueldo": {
        label: "Adelanto de Sueldo",
        subSegment: "FormularioContacto"
      },
      "estado-tramite": {
        label: "Estado de trámite efectuado",
        subSegment: "FormularioContacto"
      },
      "pedido-requerimiento": {
        label: "Pedido / Requerimiento sobre mi préstamo",
        subSegment: "FormularioContacto"
      },
      "cancelacion-anticipada": {
        label: "Cancelación anticipada",
        subSegment: "FormularioContacto"
      },
      "prestamos-uva": {
        label: "Solicitud de tratamiento especial préstamos UVA Com 'B' 121213",
        subSegment: "FormularioContacto"
      },
      "cancelacion-refinanciacion": {
        label:
          "Cancelación de Refinanciación BCRA 6964 Cancelación Total / Cancelación Parcial",
        subSegment: "FormularioContacto"
      },
      "estafa-fraude": {
        label: "Estafas y Fraudes",
        subSegment: "FormularioContacto"
      },
      otros: {
        label: "Otros",
        subSegment: "FormularioContacto"
      }
    }
  },
  seguros: {
    label: "Seguros",
    segment: "Seguros",
    items: {
      "contratar-seguro": {
        label: "Quiero contratar un seguro",
        subSegment: "FormularioContacto"
      },
      "denuncia-siniestro": {
        label: "Denuncia de siniestro",
        help: "adquisicion/Seguros"
      },
      "desconoce-producto": {
        label: "Desconoce producto",
        help: "adquisicion/Seguros"
      },
      otros: {
        label: "Otros",
        help: "adquisicion/Seguros"
      }
    }
  },
  "canales-aplicaciones": {
    label: "Canales y Aplicaciones",
    segment: "OtrosProductos",
    items: {
      "app-bbva": {
        label: "App BBVA",
        subSegment: "FormularioContacto"
      },
      modo: {
        label: "MODO",
        subSegment: "FormularioContacto"
      },
      "open-pay": {
        label: "Open Pay",
        help: "consulta/OpenPay"
      },
      go: {
        label: "GO Shop",
        subSegment: "FormularioContacto"
      }
    }
  },
  "comercio-exterior": {
    label: "Comercio Exterior",
    segment: "ComercioExterior",
    items: {
      solicitud: {
        label: "Iniciar una solicitud",
        subSegment: "FormularioContacto"
      },
      "estado-tramite": {
        label: "Estado de trámite efectuado",
        subSegment: "FormularioContacto"
      },
      "pedido-formularios": {
        label: "Pedido de formularios",
        help: "consulta/ComexPedidoFormularios"
      },
      "pedido-liquidacion": {
        label: "Pedido de liquidación",
        help: "consulta/ComexPedidoLiquidacion"
      },
      "comprobante-operaciones": {
        label: "Comprobante de operaciones internacionales",
        subSegment: "FormularioContacto"
      },
      "transferencias-exterior": {
        label: "Transferencias al exterior",
        subSegment: "FormularioContacto"
      },
      "recepcion-fondos": {
        label: "Recepción de fondos del exterior",
        subSegment: "FormularioContacto"
      },
      "instrucciones-fondos": {
        label: " Instrucciones para recibir fondos del exterior ",
        subSegment: "FormularioContacto"
      },
      "formularios-comex": {
        label: "Formularios de comercio exterior",
        subSegment: "FormularioContacto"
      }
    }
  }
};

/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleAnalyticsId: null,
  modulo: "Contacto",
  vistas: vistasConfig
};
